import { EntityType } from '../../../models/enums';
import { ContextMenuOption } from '../../../models/context-menu-option';
import { DrDocument } from '../../../models/dr-document';

enum DocumentListContextMenuOptionType {
    openDocumentInline = 'openDocumentInline',
    openDocumentInNewWindow = 'openDocumentInNewWindow',
    openFamilyInline = 'openFamilyInline',
    openFamilyInNewWindow = 'openFamilyInNewWindow',
    openThreadInline = 'openThreadInline',
    openThreadInNewWindow = 'openThreadInNewWindow',
    findExactDuplicatesOfThis = 'findExactDuplicatesOfThis',
    findContentDuplicatesOfThis = 'findContentDuplicatesOfThis',
    findNearDuplicates = 'findNearDuplicates',
    addTags = 'addTags',
    removeTags = 'removeTags',
    addTo = 'addTo',
    removeFrom = 'removeFrom',
    downloadAsPdf = 'downloadAsPdf',
    downloadNative = 'downloadNative',
    findMoreLikeThese = 'findMoreLikeThese',
    sendToDiscardPile = 'sendToDiscardPile',
    restoreFromDiscardPile = 'restoreFromDiscardPile',
}

const allDocumentListContextMenuOptions: ReadonlyMap<DocumentListContextMenuOptionType, ContextMenuOption> = new Map<DocumentListContextMenuOptionType, ContextMenuOption>([
    [DocumentListContextMenuOptionType.openDocumentInline, new ContextMenuOption({
        name: 'Open Document Inline',
        iconClass: 'fa-file-text-o'
    })],
    [DocumentListContextMenuOptionType.openDocumentInNewWindow, new ContextMenuOption({
        name: 'Open Document In New Window',
        iconClass: 'fa-file-text-o'
    })],
    [DocumentListContextMenuOptionType.openFamilyInline, new ContextMenuOption({
        name: 'Open Family Inline',
        iconClass: 'fa-paperclip', iconColor: 'color-green-04'
    })],
    [DocumentListContextMenuOptionType.openFamilyInNewWindow, new ContextMenuOption({
        name: 'Open Family In New Window',
        iconClass: 'fa-paperclip', iconColor: 'color-green-04'
    })],
    [DocumentListContextMenuOptionType.openThreadInline, new ContextMenuOption({
        name: 'Open Thread Inline',
        iconClass: 'fa-link', iconColor: 'color-blue-01'
    })],
    [DocumentListContextMenuOptionType.openThreadInNewWindow, new ContextMenuOption({
        name: 'Open Thread In New Window',
        iconClass: 'fa-link', iconColor: 'color-blue-01'
    })],
    [DocumentListContextMenuOptionType.findExactDuplicatesOfThis, new ContextMenuOption({
        name: 'Find Exact Duplicates Of This ...',
        iconClass: 'fa-files-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-search', iconSecondColor: 'color-yellow-07'
    })],
    [DocumentListContextMenuOptionType.findContentDuplicatesOfThis, new ContextMenuOption({
        name: 'Find Content Duplicates Of This ...',
        iconClass: 'fa-files-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-search', iconSecondColor: 'color-yellow-07'
    })],
    [DocumentListContextMenuOptionType.findNearDuplicates, new ContextMenuOption({
        name: 'Find Near Duplicates Of This ...',
        iconClass: 'fa-files-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-search', iconSecondColor: 'color-yellow-07'
    })],
    [DocumentListContextMenuOptionType.addTags, new ContextMenuOption({
        name: 'Add Tags ...',
        iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04'
    })],
    [DocumentListContextMenuOptionType.removeTags, new ContextMenuOption({
        name: 'Remove Tags ...',
        iconClass: 'fa-tag', iconColor: 'color-grey-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05'
    })],
    [DocumentListContextMenuOptionType.addTo, new ContextMenuOption({
        name: 'Add to ...',
        iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-plus', iconSecondColor: 'color-green-04'
    })],
    [DocumentListContextMenuOptionType.removeFrom, new ContextMenuOption({
        name: 'Remove from ...',
        iconClass: 'fa-folder', iconColor: 'color-yellow-05', iconSecondClass: 'fa-minus', iconSecondColor: 'color-red-05'
    })],
    [DocumentListContextMenuOptionType.downloadAsPdf, new ContextMenuOption({
        name: 'Download as PDF',
        iconClass: 'fa-file-pdf-o', iconColor: 'color-blue-grey-03', iconSecondClass: 'fa-download', iconSecondColor: 'color-blue-01',
    })],
    [DocumentListContextMenuOptionType.downloadNative, new ContextMenuOption({
        name: 'Download Native',
        iconClass: 'fa-download', iconColor: 'color-blue-01', iconSecondClass: 'fa-file', iconSecondColor: 'blue-grey-03'
    })],
    [DocumentListContextMenuOptionType.findMoreLikeThese, new ContextMenuOption({
        name: 'Find More Like These ...',
        iconClass: 'fa-search', iconColor: 'color-tan-07'
    })],
    [DocumentListContextMenuOptionType.sendToDiscardPile, new ContextMenuOption({
        name: 'Send to Discard Pile ...',
        iconClass: 'fa-recycle', iconColor: 'color-red-05'
    })],
     [DocumentListContextMenuOptionType.restoreFromDiscardPile, new ContextMenuOption({
        name: 'Restore from Discard Pile ...',
        iconClass: 'fa-reply', iconColor: 'color-green-05'
    })],
]);

export const DocumentListContextMenuOptionsInfo: ReadonlyMap<EntityType, Array<ContextMenuOption>> = new Map<EntityType, Array<ContextMenuOption>>([
    [EntityType.import, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInNewWindow),
        new ContextMenuOption({ divider: true }),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findExactDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findContentDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findNearDuplicates)
    )],
    [EntityType.export, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInNewWindow),
        new ContextMenuOption({ divider: true }),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findExactDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findContentDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findNearDuplicates)
    )],
    [EntityType.exportVolume, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInNewWindow),
        new ContextMenuOption({ divider: true }),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findExactDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findContentDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findNearDuplicates)
    )],
    [EntityType.projectData, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInNewWindow),
        new ContextMenuOption({ divider: true }),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findExactDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findContentDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findNearDuplicates)
    )],
    [EntityType.searchResult, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInNewWindow),
        new ContextMenuOption({ divider: true }),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findExactDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findContentDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findNearDuplicates)
    )],
    [EntityType.clusterView, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInNewWindow),
        new ContextMenuOption({ divider: true }),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findExactDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findContentDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findNearDuplicates)
    )],
    [EntityType.comparison, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInNewWindow),
        new ContextMenuOption({ divider: true }),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findExactDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findContentDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findNearDuplicates)
    )],
    [EntityType.emailThread, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInNewWindow)
    )],
    [EntityType.exceptionView, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openFamilyInNewWindow),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openThreadInNewWindow),
        new ContextMenuOption({ divider: true }),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findExactDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findContentDuplicatesOfThis),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.findNearDuplicates)
    )],
    [EntityType.discardPile, new Array<ContextMenuOption>(
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInline),
        allDocumentListContextMenuOptions.get(DocumentListContextMenuOptionType.openDocumentInNewWindow),
    )],
]);
